import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const surveyApi = createAsyncThunk(
  "auth/surveys",
  async (data, { rejectWithValue }) => {
    try {
      const paramsData = new URLSearchParams(data);
      const response = await AuthAxios.get(
        apiRoutes.surveyList, { params: data }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
const initialState = {
  result: [],
  loading: false,
  error: null,
  message: "",
  total: 0,
}
const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    resetSurvey: () =>
      initialState
  },
  extraReducers: (builder) => {
    builder.addCase(surveyApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(surveyApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.results;
      state.message = action?.payload?.message;
      state.total = action?.payload?.count;
    });
    builder.addCase(surveyApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetSurvey } = surveySlice.actions;

export const surveyReducer = surveySlice.reducer;
